import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, nichesActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, nichesActions);

export default slice.reducer;
